import { Video } from "@rootreeweb/ui";

import image from "@/assets/holiday-cards/holiday-card-holiday-video.png";
import { DayDefinition } from "../DayDefinition.js";

/**
 * Class Holiday_Video
 *
 * Represents the Holiday Video card.
 */
export class Holiday_Video extends DayDefinition {
	/** The CSS class to use for the card. */
	public className = "hl:bg-red2022";

	public image = image;
	/** The slug for the card. Used to identify the card for css, etc. */
	public slug = "holiday-video";
	/** Get the display for the card in English. */
	public initENCard(): void {
		this.title = "Happy Holidays from the Rootree Family";
		this.content = (
			<>
				<p className="hl:whitespace-pre-line">{``}</p>
				<Video
					image="https://rootree.ca/wp-content/uploads/2022/12/the-best-part-of-the-holiday-season-is.png"
					title="Happy Holidays from the Rootree Family"
					video="RK5c08jnQMk"
				/>
			</>
		);
	}

	/** Get the display for the card in French. */
	public initFRCard(): void {
		this.title = "Joyeuses Fêtes de la part de la famille Rootree !";
		this.content = (
			<>
				<p className="hl:whitespace-pre-line">
					{`Voici nos vœux en anglais uniquement.`}
				</p>
				<Video
					image="https://rootree.ca/wp-content/uploads/2022/12/the-best-part-of-the-holiday-season-is.png"
					title="Joyeuses Fêtes de la part de la famille Rootree !"
					video="RK5c08jnQMk"
				/>
			</>
		);
	}
}
